
  import { defineComponent } from "vue";
  import router from '@/router/index';

  import NetServices from '@/tools/netservices';

  import GetLanguage from '@/tools/language';
  import GeneralFx from '@/tools/general_fx';
  import appDeclarations from '@/tools/declarations';
  import DataFxs from '@/tools/data_functions';

  import Swal from "sweetalert2";
  import { OrderDeliveryStatus } from "@/models/notdb";

  const language =GetLanguage(),
    appFxs = GeneralFx(),
    dataFxs = DataFxs();
  const fNewDate = new Date(),
    year = fNewDate.getFullYear();
 

  export default defineComponent({
    name: 'SalesDelivsList',
    components: {
    },
    data(){
      return {
        appFxs,
        language,        
        isStillLoading: true,
        itemSearchKey: '',
        itemsPerPage: 5,
        selectedYear: year,
        currCode: 'RWF',
        userEmail: '',

        lstOrderDelivSituations: [] as OrderDeliveryStatus[],
        itemsPageElts: [] as OrderDeliveryStatus[],

        isPrintvisible: false,
        printInitialValues: {
          ...appFxs.getReportingData(),
          ReportToPrint: 8,
          ReportTitle: language.list_of_brands
        } as any,
        printExtraData: {},
      }
    },
    computed: {      
      filteredRecordItems(): OrderDeliveryStatus[] {
        let searchKey = this.itemSearchKey;

        if (searchKey.length === 0) return this.lstOrderDelivSituations;
        searchKey = searchKey.toLowerCase();

        const filterd = this.lstOrderDelivSituations.filter(oDev => {
          return oDev.SalesOrder.OrderNbr.toLowerCase().includes(searchKey) ||
            oDev.Customer.ClientName.toLowerCase().includes(searchKey) ||
            oDev.Staff.FirstName.toLowerCase().includes(searchKey) ||
            oDev.Staff.LastName.toLowerCase().includes(searchKey);
        });
        return filterd;
      },
    },
    methods: {
      getRecordStatus(iStatus: number){
        return iStatus == 0 ? language.not_delivered:
          iStatus == 1 ? language.part_delivery:
          language.full_delivery;
      },

      refreshList(){
        appFxs.showAjaxLoader();
        NetServices.requestGet('salesorders/delivery/getlistorderdelivsituations')
        .then(oRes => {
          if(!oRes.bReturn){
            appFxs.showAlert(oRes.msgTitle, oRes.msgBody)
              .then(vRes => {
                Swal.close();
                router.replace({ path: '/app/sales', replace: true });
              });
            return;
          }

          this.lstOrderDelivSituations = oRes.lstOrderDelivSituations!;

          Swal.close();
        });
      },
      onPageChange(evt: any){
            this.itemsPageElts = appFxs.getProxyData(evt);
      },
      
      
      printListItems(){
        const dPrint = appFxs.getReportingData();
        dPrint.ReportTitle = language.delivery_status;
        dPrint.ReportToPrint = 21;

        this.printInitialValues = dPrint;

        this.printExtraData = {
          CurrentYear: this.selectedYear,
        }

        this.isPrintvisible = true;
      },      
      onPrintClose(evt: any) {
        this.isPrintvisible = false;
        if (evt.returnType === 0) return;
      },
    },
    mounted(){   
      document.title = this.language.sales_delivs + ' - ' + this.language.appName;
      this.itemsPerPage = Number(appFxs.getLocalStorageByKey(appDeclarations.itemsPerPage, '5'));
      this.currCode = appFxs.getLocalStorageByKey(appDeclarations.currentDevise, 'RWF');
      this.userEmail = appFxs.getLocalStorageByKey(appDeclarations.userEmail, '');
      this.selectedYear = Number(appFxs.getLocalStorageByKey(appDeclarations.currentYearbook, year.toString()));
      
      NetServices.requestGet('salesorders/delivery/getlistorderdelivsituations')
        .then(oRes => {
          if(!oRes.bReturn){
            appFxs.showAlert(oRes.msgTitle, oRes.msgBody)
              .then(vRes => {
                router.replace({ path: '/app/sales', replace: true });
              });
            return;
          }

          this.lstOrderDelivSituations = oRes.lstOrderDelivSituations!;

          this.isStillLoading = false;
        });
    }
  })
